import { useState, useEffect } from 'react'
import { useEventApi } from 'hooks/use-event-api/useEventApi'
import { EventAttendee, FrontendEvent } from 'common/types'
import moment from 'moment'
import { useThemeSwitch } from 'hooks/theme'
import { useHistory, useParams } from 'react-router-dom';
import { useNotification } from 'hooks/use-notification/useNotification'
import { useUserApi } from 'hooks/use-user-api/useUserApi';
import { AttendanceType, EventAttendeesPagination, IEventMetrics, RegistrantUser } from 'common/types/event.types'

export const useAdminEventRegistrants = () => {
  const listHeadline: string[] = ['First Name', 'Last Name', 'Email', 'Status', 'Action']
  const liveActionItems: string[] = ['Check In']
  const pastActionItems: string[] = ['Delete Event', 'Duplicate Event']
  const statusList: string[] = ['Attended', 'Not Attended']
  const { mode } = useThemeSwitch()
  const { notify } = useNotification()
  const history = useHistory()
  const {
    deleteEvent,
    deleteBulkEvents,
    fetchEventAttendees
  } = useEventApi()
  const [eventsWithRegistrants, setEventsWithRegistrants] = useState<FrontendEvent[]>([])
  const [registrants, setRegistrants] = useState<EventAttendee[]>()
  const [attendeesList, setAttendeesList] = useState<RegistrantUser[]>()
  const [events, setEvents] = useState<FrontendEvent[]>()
  const [selectedEvents, setSelectedEvents] = useState([])
  const [searchCriteria, setSearchCriteria] = useState<string>('')
  const [fromDate, setFromDate] = useState<string>('')
  const [toDate, setToDate] = useState<string>('')
  const [deleteId, setDeleteId] = useState<string>('')
  const [publishId, setPublishId] = useState<string>('')
  const [statusValue, setStatusValue] = useState<string[]>(['Status'])
  const [typeValue, setTypeValue] = useState<string[]>(['Event Type'])
  const [eventType, setEventType] = useState<string[]>(['Event Type'])
  const [status, setStatus] = useState<string[]>(['Status'])
  const [showFilter, setShowFilter] = useState<boolean>(false)
  const [showDelete, setShowDelete] = useState<boolean>(false)
  const [filterToDateDisabled, setFilterToDateDisabled] = useState<boolean>(false)
  const [showDeleteMultiple, setShowDeleteMultiple] = useState<boolean>(false)
  const [checkedEvents, setCheckedEvents] = useState<string[]>([])
  const {eventId} = useParams<{ eventId: string }>()
  const {fetchUser} = useUserApi()
  const [registrantsTotalCount, setRegistrantsTotalCount] = useState(0)
  const [eventRegistrantsPage, setEventRegistrantsPage] = useState(1)
  const { fetchEventAttendeesMetricsByEventId} = useEventApi()
  const [metrics, setMetrics] = useState<IEventMetrics[]>()


  const mergeRegistrant = async () => {
    const eventAttendeesPageSize = 10
    const response: EventAttendeesPagination = await fetchEventAttendees(eventId, eventRegistrantsPage, eventAttendeesPageSize)

    if(response?.data){
      const attendants = await Promise.all(
        response?.data?.map(async registrant => {
          const user = await fetchUser(registrant?.attendeeId)
          return {
            ...user,
            status: registrant?.status as string,
            attendeeId: registrant?.id as string,
            attendanceType: registrant.attendanceType as AttendanceType
          } as RegistrantUser
        })
      )
      setRegistrantsTotalCount(Number(response?.totalCount))
      setAttendeesList([...(attendeesList || []), ...attendants])
    }    
  }

  const getMetrics = async () => {
    const metrics = (await fetchEventAttendeesMetricsByEventId(eventId))
    setMetrics(metrics)
  }

  useEffect(() => {
    getMetrics()
  }, [])

  useEffect(() =>{
    mergeRegistrant()
  }, [ eventRegistrantsPage ]);

  useEffect(() => {
    if (fromDate && toDate) {
      const isLess = moment(fromDate).isAfter(moment(toDate))
      setFilterToDateDisabled(isLess)
    }

    statusValue?.length === 0 ? setStatusValue(['Status']) : statusValue
    typeValue?.length === 0 ? setTypeValue(['Event Type']) : typeValue
   
  }, [status, fromDate, toDate, searchCriteria, statusValue, selectedEvents, typeValue, eventType, eventId])

  return {
    eventsWithRegistrants,
    attendeesList,
    setEvents,
    events,
    deleteEvent,
    searchCriteria,
    setSearchCriteria,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    selectedEvents,
    setSelectedEvents,
    showDelete,
    setShowDelete,
    showDeleteMultiple,
    setShowDeleteMultiple,
    deleteId,
    setDeleteId,
    showFilter,
    setShowFilter,
    statusValue,
    setEventsWithRegistrants,
    deleteBulkEvents,
    publishId,
    setPublishId,
    filterToDateDisabled,
    listHeadline,
    liveActionItems,
    pastActionItems,
    statusList,
    history,
    mode,
    notify,
    typeValue,
    checkedEvents,
    setCheckedEvents,
    setRegistrants,
    registrants,
    eventId,
    registrantsTotalCount,
    eventRegistrantsPage,
    setEventRegistrantsPage,
    metrics
  } as const
}
